import { styled } from '@mui/material/styles';
import { FormGroupProps } from './form-group.interfaces';
import { FormGroup } from '@mui/material';

const BORDER_RADIUS = 15;

export const FormGroupStyled = styled(FormGroup)<FormGroupProps>(({ direction }) => ({
  '&.MuiFormGroup-root': {
    flexDirection: direction ? direction : 'column',
    alignItems: direction != 'row' && 'flex-start',
    flexWrap: 'nowrap',
    '& .MuiFormControl-root': {
      borderRadius: `0px`,
    },
    '& .MuiFormControl-root:not(:first-of-type)': {
      borderLeft: direction == 'row' && `unset`,
    },
    '&:first-of-type': {
      '& .MuiFormControl-root:first-of-type': {
        borderTopLeftRadius: `${BORDER_RADIUS}px`,
        borderTopRightRadius: direction != 'row' && `${BORDER_RADIUS}px`,
      },
      '& .MuiFormControl-root:last-of-type': {
        borderTopRightRadius: direction == 'row' && `${BORDER_RADIUS}px`,
        borderBottomRightRadius: direction != 'row' && `${BORDER_RADIUS}px`,
        borderBottomLeftRadius: direction != 'row' && `${BORDER_RADIUS}px`,
      },
    },
    '&:last-of-type': {
      '& .MuiFormControl-root:first-of-type': {
        borderBottomLeftRadius: direction == 'row' && `${BORDER_RADIUS}px`,
      },
      '& .MuiFormControl-root:last-of-type': {
        borderBottomRightRadius: direction == 'row' && `${BORDER_RADIUS}px`,
      },
      '& .MuiFormControl-root:not(:first-of-type)': {
        borderTop: direction != 'row' && `unset`,
      },
    },
    '&:not(:first-of-type)': {
      '& .MuiFormControl-root': {
        borderTop: direction == 'row' && `unset`,
      },
    },
  },
}));
